import React from "react";
import { Row, Col } from "reactstrap";
import PropTypes from "prop-types";
import { FormattedDate, FormattedNumber } from "react-intl";

import { CustomFormInput, FormField } from "../../../../utils/FormFields";
import ProvisionsPaymentAccount from "./Accounts";

const ProvisionsPayment = ({ payment }) => (
  <React.Fragment>
    <Row>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Settlement Date">
          <FormattedDate value={`${payment.ProvisionsPaymentSettlementDate}T00:00`} />
        </CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Status">{payment.ProvisionsPaymentStatus}</CustomFormInput>
      </Col>

      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Description">{payment.ProvisionsPaymentDescription}</CustomFormInput>
      </Col>
    </Row>
    <hr />
    <ProvisionsPaymentAccount accounts={payment.Accounts} />
  </React.Fragment>
);

ProvisionsPayment.propTypes = {
  earning: PropTypes.object.isRequired,
};

export default ProvisionsPayment;
